import { render, staticRenderFns } from "./errorPage.vue?vue&type=template&id=d9c4fc36&scoped=true"
import script from "./errorPage.vue?vue&type=script&lang=js"
export * from "./errorPage.vue?vue&type=script&lang=js"
import style0 from "./errorPage.vue?vue&type=style&index=0&id=d9c4fc36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c4fc36",
  null
  
)

export default component.exports